import "./about.scss"
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
const AboutMe = () => {
  return (
    <div className="about-page">
      <>
          <Helmet>
              <title>Pro Moto - poznaj nas bliżej</title>
              <meta
              name="description"
              content="PRO MOTO to zespół pasjonatów dwóch kółek, który od 2010 
              roku zajmuje się serwisem i sprzedażą motocykli, quadów oraz skuterów. 
              Nasz serwis w Mrowinie łączy doświadczenie mechaników z miłością do jazdy
               – dlatego naprawiamy i przygotowujemy maszyny tak, jakby były nasze własne."
              />
              <link rel="canonical" href="https://promotoserwis.pl/o-firmie" />
          </Helmet>
      </>
      <section className="about-hero">
        <div className="about-hero__content">
          <motion.h1
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}>O FIRMIE</motion.h1>
          <motion.h2
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}>PRO MOTO — poznaj nas bliżej</motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}>
              PRO MOTO to zespół pasjonatów dwóch kółek, 
              który od 2010 roku zajmuje się serwisem i sprzedażą motocykli, 
              quadów oraz skuterów. Nasz serwis w Mrowinie łączy doświadczenie 
              mechaników z miłością do jazdy – dlatego naprawiamy i przygotowujemy 
              maszyny tak, jakby były nasze własne.
          </motion.p>

          <motion.p 
            initial={{ opacity: 0, y: 90 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="email">
            e-mail:
            <a href="mailto:promotoserwismotocyklowy@gmail.com">
              promotoserwismotocyklowy@gmail.com
            </a>
          </motion.p>

          <button
            className="about-scroll-btn"
            onClick={() =>
              document.querySelector(".about-extra").scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="arrow"></span>
          </button>
        </div>
      </section>


      <section className="about-extra">
        <div className="about-extra__container">

          <div className="about-block">
            <h2>Nasza misja</h2>
            <p>
              Chcemy, by każdy motocyklista <strong>jeździł bezpiecznie i na sprzęcie, któremu ufa.</strong>
              Dlatego dokładnie diagnozujemy usterki, transparentnie wyceniamy prace i
              oferujemy wyłącznie sprawdzone motocykle używane po pełnym przeglądzie.
            </p>
          </div>

          <div className="about-block">
            <h2>Co nas wyróżnia?</h2>
            <ul>
              <li><strong>Średnia ocena 4.8 ★</strong> – potwierdzone zaufanie klientów na Google.</li>
              <li><strong>Przejrzystość</strong> – jasna wycena przed rozpoczęciem prac, brak ukrytych kosztów.</li>
              <li><strong>Terminowość</strong> – szanujemy Twój czas i sezon motocyklowy.</li>
              <li><strong>Pełna oferta w jednym miejscu</strong> – serwis, lakiernia, transport, zimowanie, komis i skup.</li>
              <li><strong>Motocykliści dla motocyklistów</strong> – rozumiemy Twoje potrzeby, bo sami jeździmy.</li>
            </ul>
          </div>

          <div className="about-block">
            <h2>Jak pracujemy?</h2>
            <ol>
              <li><strong>Diagnoza & konsultacja</strong> – najpierw słuchamy właściciela i sprawdzamy sprzęt.</li>
              <li><strong>Wycena</strong> – wiesz dokładnie, co i za ile robimy.</li>
              <li><strong>Serwis na czas</strong> – części zamawiamy od ręki, prace wykonujemy według harmonogramu.</li>
              <li><strong>Odbiór lub transport</strong> – możesz odebrać osobiście lub zlecić dostawę pod drzwi.</li>
              <li><strong>Wsparcie po naprawie</strong> – doradzamy i służymy pomocą w razie potrzeby.</li>
            </ol>
          </div>

          <div className="about-block about-block--final">
            <h2>Zapraszamy do kontaktu</h2>
            <p>
              Masz pytania? Chcesz umówić serwis lub obejrzeć motocykle na sprzedaż?
              Zadzwoń lub odwiedź nas w Mrowinie — <strong>kawa i motocyklowe rozmowy czekają!</strong>
            </p>
          </div>

        </div>
      </section>
    </div>
  );
};

export default AboutMe;
